import { render, staticRenderFns } from "./Account.vue?vue&type=template&id=1b02d320&"
import script from "./Account.vue?vue&type=script&lang=js&"
export * from "./Account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/.jenkins/workspace/crm-ui/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b02d320')) {
      api.createRecord('1b02d320', component.options)
    } else {
      api.reload('1b02d320', component.options)
    }
    module.hot.accept("./Account.vue?vue&type=template&id=1b02d320&", function () {
      api.rerender('1b02d320', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/profile/components/Account.vue"
export default component.exports